import { message } from 'ant-design-vue'
import _ from "lodash"

export const toast = ({ type = 'error', msg }) => {
  msg = _.isString(msg) ? msg : msg?.response?.data?.message || msg?.response?.statusText || msg?.message || 'Error'
  message[type](msg)
};